import { render } from "./send-notification-modal.vue?vue&type=template&id=82a0f540"
import script from "./send-notification-modal.vue?vue&type=script&lang=js"
export * from "./send-notification-modal.vue?vue&type=script&lang=js"

import "./send-notification-modal.vue?vue&type=style&index=0&id=82a0f540&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__